export default "__VITE_ASSET__DV66UPQu__"